const AUTH_KEY = "easyshare:auth";

export interface AuthState {
  userId: string;
  loggedInAt: string;
}

export function getAuthState(): AuthState | null {
  try {
    const raw = sessionStorage.getItem(AUTH_KEY) || localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthState;
    if (!parsed?.userId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getAuthUserId(): string | null {
  return getAuthState()?.userId || null;
}

export function setAuthState(userId: string, persist = true) {
  const state: AuthState = { userId, loggedInAt: new Date().toISOString() };
  const raw = JSON.stringify(state);
  sessionStorage.setItem(AUTH_KEY, raw);
  if (persist) localStorage.setItem(AUTH_KEY, raw);
  else localStorage.removeItem(AUTH_KEY);
}

export function clearAuthState() {
  sessionStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(AUTH_KEY);
}
